import { AuthProvider } from "@descope/react-sdk";


export const AuthWrapper = ({ children }) => {
	console.log('DESCOPE_ENABLED',process.env.REACT_APP_SSO_LOGIN_DESCOPE_ENABLED)
	if (process.env.REACT_APP_SSO_LOGIN_DESCOPE_ENABLED !== 'true') {
		return <>{children}</>;
	}
	return (
		<AuthProvider
			projectId={`${process.env.REACT_APP_OIDC_CLIENT_ID}`}
			sessionTokenViaCookie={{ sameSite: "Lax" }}
			oidcConfig={{
				applicationId: `${process.env.REACT_APP_DESCOPE_OIDC_APPLICATION_ID}`,
			}}
			baseUrl={`${process.env.REACT_APP_API_SICUREZZA_DESCOPE_BASE_URL}`}
		>
			{children}
		</AuthProvider>
	);
};

export default AuthWrapper;